/*
 * @Author: PanYunhong
 * @Date: 2022-07-08 13:14:14
 * @LastEditors: ziyongqiang
 * @LastEditTime: 2024-04-15 16:00:32
 */
import qs from 'qs';
import axios from 'axios';
import { get, post, postRequest, } from '@/request/request';
import { message, } from 'ant-design-vue';
import { serverIp, constructionSitesIp, } from '@/configs/index';

/**
 *  污染源统计——餐饮
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const cookStatisticalPro = (params:any) => postRequest(`/pollutionAnalyze/cookStatisticalPro`, params);

/**
 *  污染源统计——全部
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const summaryStatisticalPro = (params:any) => postRequest(`/pollutionAnalyze/summaryStatisticalPro`, params);

/**
 *  污染源统计——工地
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const constructionStatisticalExceed = (params:any) => postRequest(`/pollutionAnalyze/constructionStatisticalExceed`, params);

/**
 *  污染源统计——工地
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const constructionDischargeTrendAnalysis = (params:any) => postRequest(`/pollutionAnalyze/constructionDischargeTrendAnalysis`, params);

/**
 *  污染源统计——工地
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const constructionDischargeRankAnalysis = (params:any) => postRequest(`/pollutionAnalyze/constructionDischargeRankAnalysis`, params);

/**
 *  污染源统计——工地
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const constructionStatisticalPro = (params:any) => postRequest(`/pollutionAnalyze/constructionStatisticalPro`, params);

/**
 *  污染源统计——企业
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const companyStatisticalExceed = (params:any) => postRequest(`/pollutionAnalyze/companyStatisticalExceed`, params);

/**
 *  污染源统计——企业
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const companyDischargeTrendAnalysis = (params:any) => postRequest(`/pollutionAnalyze/companyDischargeTrendAnalysis`, params);

/**
 *  污染源统计——企业
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const companyDischargeRankAnalysis = (params:any) => postRequest(`/pollutionAnalyze/companyDischargeRankAnalysis`, params);

/**
 *  污染源统计——企业
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const companyStatisticalPro = (params:any) => postRequest(`/pollutionAnalyze/companyStatisticalPro`, params);

/**
 *  餐饮列表
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const searchCookList = (params:any) => post(`/pollutionAnalyze/searchCookList`, params);

/**
 *  餐饮列表详情-监测分析
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const searchCookInfo = (params:any) => postRequest(`/pollutionAnalyze/searchCookInfo`, params);

/**
 *  企业列表
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const searchCompanyList = (params:any) => post(`/pollutionAnalyze/searchCompanyList`, params);

/**
 *  企业列表
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const searchCompanyInfo = (params:any) => postRequest(`/pollutionAnalyze/searchCompanyInfo`, params);

/**
 *  工地列表
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const searchConstructionList = (params:any) => post(`/pollutionAnalyze/searchConstructionList`, params);

/**
 *  工地列表详情-监测分析
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const searchConstructionInfo = (params:any) => postRequest(`/pollutionAnalyze/searchConstructionInfo`, params);

/**
 *  污染源超标统计
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const pollutionExceededStatistics = (params:any) => postRequest(`/pollutionAnalyze/pollutionExceededStatistics`, params);

/**
 *  工地管理系统登录
 * @param {any} params 参数
 * @returns {any} 结果
 */
export const constructionSitesManagementLogin = (): any => {
  const params = {
    account: 'gaochunqu',
    password: 'gc12369',
    loginType: 2,
  };

  return new Promise((resolve, reject) => {
    axios.post(
      `${constructionSitesIp}/building/user/login`,
      qs.stringify(params)

      /*
       * {
       *   headers: {
       *     'Access-Control-Allow-Origin': '*',
       *     'Access-Control-Allow-Credentials': 'true',
       *     'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, PATCH, OPTIONS',
       *     'Access-Control-Allow-Headers': 'DNT,X-Mx-ReqToken,Keep-Alive,User-Agent,X-Requested-With,If-Modified-Since,Cache-Control,Content-Type,Authorization,user-access-token, user-refresh-token',
       *   },
       * }
       */
    )
      .then(({ data, status, }) => {
        if (status === 200) {
          resolve(data.data);
        } else {
          reject(data.msg);
          message.error('免登录失败请稍后再试');
        }
      })
      .catch((err) => {
        reject(err.data);
        message.error('免登录失败请稍后再试');
      });
  });
};

// 污染源列表-获取清单列表
export const getPollutionTable = (params:any) => postRequest(`/gaoChunPollute/selectPolluteData`, params);

// 污染源列表-获取区域选项
export const getPollutionRegion = (): any => new Promise((resolve,reject) => {
  axios.get(`${serverIp}/gaoChunPollute/selectPolluteArea`).then(({ data, }) => {
    if (Number(data.code) === 200) {
      resolve(data.data);
    } else {
      message.error('请求出错：',data.msg);
      reject(data.msg);
    }
  });
});

// 污染源列表-通知下发
export const sendNotice = (params:any) => postRequest(`/gaoChunPollute/sendMessage`, params);

// 污染源列表-通知下发-工单
export const sendRepairOrder = (params:any): any => postRequest('/gaoChunPollute/sendRepairOrder',params);

// 污染源列表-在线监控-用电监测企业-用电趋势
export const getElectData = (params:any) => postRequest(`/pollutionAnalyze//searchElectricTrend`, params);
// 污染源列表-在线监控-用电监测企业-用电明细
export const getElectDetail = (params:any) => postRequest(`/pollutionAnalyze/searchElectricDetail`, params);

// 用电企业列表
export const searchElectList = (params:any) => post(`/pollutionAnalyze/searchElectricList`, params);
// 停车场企业列表
export const searchCarList = (params:any) => post(`/gaoChunCamera/getList`, params);

// 请求摄像头tree
export const getCamerasTree = (params:any): any => new Promise((resolve,reject) => {
  axios.post(`${serverIp}/camera/findCameraList`,params).then(({ data, }) => {
    if (data.code === '200') {
      resolve(data.data);
    } else {
      reject(data.msg);
    }
  });
});

// 请求视频url
export const getCameraUrl = (): any => new Promise((resolve,reject) => {
  axios.get(`${serverIp}/gaoChunPollute/selectPolluteArea`).then(({ data, }) => {
    if (Number(data.code) === 200) {
      // resolve(data.data);

      //  resolve(camerasData.data);
    } else {
      message.error('请求出错：',data.msg);
      reject(data.msg);
    }
  });
});

// 云台控制
export const operationCamera = async (params:any) => {
  // 开启
  const res = await axios({
    method: 'post',
    url: 'https://open.ys7.com/api/lapp/device/ptz/start',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
  });

  if (res.data.code === '200') {
    // 暂停
    await axios({
      method: 'post',
      url: 'https://open.ys7.com/api/lapp/device/ptz/stop',
      params,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
    });
  } else if (res.data.msg) {
    // message.error(res.data.msg);
  }

  return true;
};
// 请求天翼视频url
export const getCameraTianYiUrl = (params:any): any => new Promise((resolve,reject) => {
  axios.post(`${serverIp}/dxCamera/getDeviceMediaUrl`,params).then(({ data, }) => {
    if (data.data) {
      const { url, } = JSON.parse(data.data);

      resolve(url);
    }
  });
});

// 获取企业列表
export const getLists = (url:string,params:any) => postRequest(url, params);

// 获取企业列表
export const noticeLists = (params:any) => post('/illegal/notice/query', params);

export const statisticsLists = (params:any) => postRequest('/illegal/notice//statistics', params);

export const getCategory = () => postRequest('/illegal/notice/category');

export const searchAlarmList = (params:any) => postRequest('/pollutionAnalyze/searchAlarmList', params);

export const exceededTable = (params:any) => postRequest('/pollutionAnalyze/exceededTable', params);

export const exceededTableInfo = (params:any) => postRequest('/pollutionAnalyze/exceededTableInfo', params);

export const selectMessage = (params:any) => postRequest('/gaoChunPollute/selectMessage', params);

// 编辑污染源清单
export const updatePolluteList = (params:any) => postRequest('/gaoChunPollute/updatePolluteData', params);

// 污染源监管-下发通知保存草稿
export const addMessageDraft = (params:any) => postRequest('/gaoChunPollute/insertMessageDraft', params);
// 污染源监管-下发通知草稿列表
export const getMessageDraft = (params:any) => postRequest('/gaoChunPollute/selectDraft', params);
// 污染源监管-更新草稿
export const updateMessageDraft = (params:any) => postRequest('/gaoChunPollute/updateMessageDraft', params);
export const delMessageDraft = (params:any) => postRequest('/gaoChunPollute/deleteDraft', params);
export const getPollutionRepair = (params:any) => postRequest('/gaoChunPollute/selectPollutionRepair', params);
export const getMessage = (params:any) => postRequest('/gaoChunPollute/selectPollutionMsg', params);
export const getTicketHistory = (params:any) => postRequest('/repair/getRepairOrderInfoById', params);

// 导入、导出Excel
export const importExcel = (type:string,params:any) => postRequest(`/gaoChunPollute/importExcel?type=${type}`, params);
export const exportExcel = (type: any) => axios({
  method: 'POST',
  url: `${serverIp}/gaoChunPollute/exportExcel?type=${type}`,
  responseType: 'blob',
}).then((res:any) => {
  const fileName = decodeURI(res.headers['content-disposition'].split('=')[1]);
  const url = window.URL.createObjectURL(new Blob([res.data,], { type: 'application/vnd.ms-excel', }));
  const a = document.createElement('a');

  a.style.display = 'none';
  a.download = fileName;
  a.href = url;
  a.click();
});
